import { Company } from 'core/models/company';

/** Companies of this type are cooperative societies (جمعيات تعاونية). */

/** A single member can not own more than this percentage of the society shares. */
export const COOPERATIVE_MAX_OWNERSHIP_PERCENTAGE = 10;

export const isCooperativeCompany = (company?: Company | null) => company?.company_type?.legal_entity_type === 'cooperative_society';
